/* eslint-env jest */
import {
  isSeniorBuyAllUpsell,
  isYearbookLine,
  isBasePackage,
  wouldStrandUpsell,
  orphanedUpsellIds,
} from './buyAllUpsell';

// The senior "Buy All" upsell is an add-on that can't stand alone, scoped
// per-student (a cart can hold multiple seniors). op.option() returns the option.
const op = ({ id, studentId, optionName = 'Senior Print Package', promo = false }) => ({
  id,
  studentId,
  option: () => ({ name: optionName, seniorBuyAllPromo: promo }),
});

const base = (id, studentId) => op({ id, studentId });
const upsell = (id, studentId) => op({ id, studentId, optionName: 'Buy All Your Photos', promo: true });
const yearbook = (id, studentId) => op({ id, studentId, optionName: 'Select Yearbook Pose' });

describe('buyAllUpsell classification', () => {
  it('identifies the upsell, the yearbook line, and base packages', () => {
    expect(isSeniorBuyAllUpsell(upsell(2, 1))).toBe(true);
    expect(isSeniorBuyAllUpsell(base(1, 1))).toBe(false);

    expect(isYearbookLine(yearbook(3, 1))).toBe(true);
    expect(isYearbookLine(base(1, 1))).toBe(false);

    expect(isBasePackage(base(1, 1))).toBe(true);
    expect(isBasePackage(upsell(2, 1))).toBe(false);
    expect(isBasePackage(yearbook(3, 1))).toBe(false); // free yearbook line is NOT a base package
  });
});

describe('wouldStrandUpsell', () => {
  it('is true when deleting a student\'s only base package while they hold the upsell', () => {
    const cart = [base(1, 1), upsell(2, 1), yearbook(3, 1)];
    expect(wouldStrandUpsell(cart, base(1, 1))).toBe(true);
  });

  it('is false when that student has another base package', () => {
    const cart = [base(1, 1), base(4, 1), upsell(2, 1)];
    expect(wouldStrandUpsell(cart, base(1, 1))).toBe(false);
  });

  it('is false when the upsell belongs to a DIFFERENT student (family cart)', () => {
    // Deleting student 1's package must not implicate student 2's upsell.
    const cart = [base(1, 1), base(5, 2), upsell(6, 2)];
    expect(wouldStrandUpsell(cart, base(1, 1))).toBe(false);
  });

  it('is false when deleting the upsell itself or the yearbook line', () => {
    const cart = [base(1, 1), upsell(2, 1), yearbook(3, 1)];
    expect(wouldStrandUpsell(cart, upsell(2, 1))).toBe(false);
    expect(wouldStrandUpsell(cart, yearbook(3, 1))).toBe(false);
  });
});

describe('orphanedUpsellIds', () => {
  it('returns the student\'s upsell ids once their base package is gone', () => {
    const remaining = [upsell(2, 1), yearbook(3, 1)]; // base already filtered out
    expect(orphanedUpsellIds(remaining, 1)).toEqual([2]);
  });

  it('returns none when that student still has a base package', () => {
    const remaining = [base(4, 1), upsell(2, 1)];
    expect(orphanedUpsellIds(remaining, 1)).toEqual([]);
  });

  it('only touches the deleted student, never another senior in the cart', () => {
    const remaining = [upsell(2, 1), base(5, 2), upsell(6, 2)];
    expect(orphanedUpsellIds(remaining, 1)).toEqual([2]); // student 2 keeps upsell 6
  });
});
